<div class="FormsArticle">
    @if (isLoading || isSaving) {
        <app-pg-loading [isOverlay]="isSaving"></app-pg-loading>
    }
    @if (!isLoading) {
        @if (viewOnly) {
            <div>
                <app-pg-detail [formLayout]="formLayout" [hideEmpty]="true" [currentLanguage]="true"></app-pg-detail>
            </div>
        }
        @if (!viewOnly) {
            <div [hidden]="createModalData != null">
                <app-pg-form #formComponent [formLayout]="formLayout" [hasSubmit]="false" [hideAdvanced]="true" (advancedModeChange)="onAdvancedModeChange($event)" [forceLanguage]="selectedLanguage" (valueChange)="onValueChange($event)"></app-pg-form>
            </div>
        }
        <div>
            <h5 class="my-3 pb-3 border-bottom">{{ 'forms-article.external-poi-title' | locTranslate }}</h5>
            @for (poi of externalPoiList; track poi) {
                <div class="row FormsArticle-ExternalPoi">
                    @for (field of externalPoiFields; track field; let i = $index) {
                        <div class="col">
                            @if (!viewOnly) {
                                <app-pg-form-field [fieldData]="field" [(ngModel)]="poi[field.name]" (ngModelChange)="onExternalPoiValueChange()"></app-pg-form-field>
                            }
                            @if (viewOnly) {
                                <div class="{{ i > 0 ? 'mt-3' : ''}}">
                                    <app-pg-detail-field [fieldData]="field" [value]="poi[field.name]"></app-pg-detail-field>
                                </div>
                            }
                        </div>
                    }
                    @if (!viewOnly) {
                        <div class="col">
                            <button type="button" class="btn btn-danger" (click)="delExternalPoi(poi)"
                                [attr.aria-label]="'forms-main.a11y.delete-item' | locTranslate">
                                <i class="fa-regular fa-trash" aria-hidden="true"></i>
                            </button>
                        </div>
                    }
                </div>
            }
            @if (!viewOnly) {
                <div class="row mt-3">
                    <div class="col-12">
                        <button type="button" class="btn btn-primary" (click)="addExternalPoi()">
                            <i class="fa-regular fa-plus" aria-hidden="true"></i>
                            <span>{{ 'forms-article.external-poi-add' | locTranslate }}</span>
                        </button>
                    </div>
                </div>
            }
            <div>
                <div class="border-bottom pb-3 d-flex justify-content-between align-items-center my-3">
                    <h5 class="m-0">{{ 'forms-article.paragraphs-title' | locTranslate }}</h5>
                </div>
                @for (paragraph of paragraphsList; track paragraph; let i = $index) {
                    <div class="row mb-3">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-body FormsArticle-Card {{ viewOnly ?  'FormsArticle-Card--ViewOnly' : ''}}">
                                    <div>
                                        @if (!viewOnly) {
                                            <div class="d-flex align-items-center FormsArticle-Paragraph-Buttons">
                                                <button type="button" [disabled]="i <= 0" class="btn btn-link" (click)="moveParagraphPrev(paragraph)"
                                                    [attr.aria-label]="'forms-main.a11y.move-up' | locTranslate">
                                                    <i class="fa-regular fa-chevron-up" aria-hidden="true"></i>
                                                </button>
                                                <h5 class="m-0">{{ i + 1 }}</h5>
                                                <button type="button" [disabled]="i >= paragraphsList.length - 1" class="btn btn-link" (click)="moveParagraphNext(paragraph)"
                                                    [attr.aria-label]="'forms-main.a11y.move-down' | locTranslate">
                                                    <i class="fa-regular fa-chevron-down" aria-hidden="true"></i>
                                                </button>
                                                <div>
                                                    <app-pg-confirm-action (confirmed)="deleteParagraph(paragraph)">
                                                        <button type="button" class="btn btn-link text-danger"
                                                            [attr.aria-label]="'forms-main.a11y.delete-item' | locTranslate">
                                                            <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                                        </button>
                                                    </app-pg-confirm-action>
                                                </div>
                                            </div>
                                        }
                                        @for (field of paragraphsFields; track field; let i = $index) {
                                            <div>
                                                @if (!viewOnly) {
                                                    <app-pg-form-field [languages]="formLanguages" [fieldData]="field" [(ngModel)]="paragraph[field.name]" (ngModelChange)="onParagraphValueChange()" [realmId]="getRealmId()"></app-pg-form-field>
                                                }
                                                @if (viewOnly) {
                                                    <div class="{{ i > 0 ? 'mt-3' : ''}}">
                                                        <app-pg-detail-field [languages]="formLanguages" [fieldData]="field" [value]="paragraph[field.name]"></app-pg-detail-field>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        <h5 class="my-3 pb-3 border-bottom">{{ 'forms-article.paragraphs-links-title' | locTranslate }}</h5>
                                        @for (link of paragraph.links; track link) {
                                            <div class="row FormsArticle-Paragraph-Link">
                                                @if (viewOnly) {
                                                    @for (field of paragraphsLinkFields; track field; let i = $index) {
                                                        <div class="col-6">
                                                            <app-pg-detail-field [fieldData]="field" [value]="link[field.name]"></app-pg-detail-field>
                                                        </div>
                                                    }
                                                }
    
                                                @if (!viewOnly) {
                                                    @for (field of paragraphsLinkFields; track field; let i = $index) {
                                                        <div class="col">
                                                            <app-pg-form-field [fieldData]="field" [(ngModel)]="link[field.name]" (ngModelChange)="onParagraphValueChange()"></app-pg-form-field>
                                                        </div>
                                                    }
                                                
                                                    <div class="col">
                                                        <button type="button" class="btn btn-danger" (click)="delParagraphLink(paragraph, link)"
                                                            [attr.aria-label]="'forms-main.a11y.delete-item' | locTranslate">
                                                            <i class="fa-regular fa-trash" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        @if (!viewOnly) {
                                            <div class="row mt-3">
                                                <div class="col-12">
                                                    <button type="button" class="btn btn-primary" (click)="addParagraphLink(paragraph)">
                                                        <i class="fa-regular fa-plus" aria-hidden="true"></i>
                                                        <span>{{ 'forms-article.paragraphs-links-add' | locTranslate }}</span>
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                @if (!viewOnly) {
                    <div class="row mb-2">
                        <div class="col-12">
                            <button type="button" class="btn btn-primary" (click)="addParagraph()">
                                <i class="fa-regular fa-plus" aria-hidden="true"></i>
                                <span>{{ 'forms-article.paragraphs-add' | locTranslate }}</span>
                            </button>
                        </div>
                    </div>
                }
            </div>
        </div>
    }
</div>